import { MessageCircle } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

const NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "";
// Hide the floating WhatsApp button entirely until a verified WhatsApp Business
// number is registered. Set REACT_APP_WHATSAPP_ENABLED=true in frontend/.env
// once the number is live in WhatsApp Business.
const ENABLED = String(process.env.REACT_APP_WHATSAPP_ENABLED).toLowerCase() === "true";

export const WhatsAppButton = () => {
  if (!ENABLED || !NUMBER) return null;
  const text = encodeURIComponent("Hi USDD — I'd like to enquire about your programmes.");
  return (
    <a
      href={`https://wa.me/${NUMBER}?text=${text}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-btn"
      onClick={() => trackEvent("whatsapp_click", { source: "float_button" })}
      className="fixed bottom-5 right-5 z-50 group flex items-center gap-2 px-4 py-3 rounded-full bg-[#25D366] text-black font-bold text-xs uppercase tracking-wider shadow-[0_8px_30px_rgba(37,211,102,0.45)] hover:scale-105 hover:bg-[#1FB659] transition-all"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={18} fill="black" />
      <span className="hidden sm:inline">Chat on WhatsApp</span>
    </a>
  );
};
